export default {
  data() {
    return {
      emptyTypes: [
        {
          code: 'LSR',
          name: 'Loze sparing (rond)',
          icon: '07_lkr.svg',
          systems: [
            {
              code: 'WBD60 (1x)',
              name: 'WBD60 systeem, 1 x 60mm HD afdichtplaat 747. Afwerken met Mastic M701/721/722'
            },
            {
              code: 'WBD60 (2x)',
              name: 'WBD60 systeem, 2 x 60mm HD afdichtplaat 747. Afwerken met Mastic M701/721/722'
            }
          ],
          sizeCategoryTitle: 'Max doorsnee in mm',
          sizeCategories: ['100', '200', '300', '400', '500', '600', '700', '800', '1000']
        },
        {
          code: 'LSV',
          name: 'Loze sparing (vierkant)',
          icon: '08_lkv.svg',
          systems: [
            {
              code: 'WBD60 (1x)',
              name: 'WBD60 systeem, 1 x 60mm HD afdichtplaat 747. Afwerken met Mastic M701/721/722'
            },
            {
              code: 'WBD60 (2x)',
              name: 'WBD60 systeem, 2 x 60mm HD afdichtplaat 747. Afwerken met Mastic M701/721/722'
            }
          ],
          sizeCategoryTitle: 'Max zijde in mm',
          sizeCategories: ['100', '200', '300', '400', '500', '600', '700', '800', '1000']
        }
      ],
      mechanicalTypes: [
        {
          code: 'LKV-S',
          name: 'Luchtkanaal rechthoekig, zonder brandklep, zonder isolatie, rookdicht afdichten rondom',
          icon: '09_lkv-s.svg',
          systems: [
            {
              code: 'WBD60 (1x) / Ductrock',
              name: 'WBD60 Systeem, 1 x 60 mm HD afdichtplaat 747. LK geheel bw isoleren Ductrock over lengte in ruimte'
            },
            {
              code: 'WBD60 (1x) / Brandklep',
              name: 'WBD60 Systeem, 1 x 60 mm HD afdichtplaat 747. Doorzagen en rechthoekige brandklep plaatsen'
            },
            {
              code: 'WBD60 (2x) / Ductrock',
              name:
                'WBD60 Systeem, 2 x >50 mm HD afdichtplaat 747. LK geheel bw isoleren Ductrock over lengte in ruimte'
            },
            {
              code: 'WBD60 (2x) / Brandklep',
              name: 'WBD60 Systeem, 2 x >50 mm HD afdichtplaat 747. Doorzagen en rechthoekige brandklep plaatsen'
            }
          ],
          sizeCategoryTitle: 'Max zijde in mm',
          sizeCategories: ['100', '200', '250', '300', '500', '600', '750', '1000', '1500', '2000']
        },
        {
          code: 'BKV-IN',
          name: 'Luchtkanaal rechthoekig, met brandklep in BSC, afdichten tpv BK in wand',
          icon: '10_bkv-in.svg',
          systems: [
            {
              code: 'WBD60 (1x)',
              name:
                'WBD60 Systeem, 1 x 60 mm HD afdichtplaat 747\n' + 'Brandwerend afdichten ter plaatse van de brandklep'
            },
            {
              code: 'WBD60 (2x)',
              name:
                'WBD60 Systeem, 2 x >50 mm HD afdichtplaat 747\n' + 'Brandwerend afdichten ter plaatse van de brandklep'
            }
          ],
          sizeCategoryTitle: 'Max zijde in mm',
          sizeCategories: ['100', '200', '250', '300', '500', '600', '750', '1000', '1500', '2000']
        },
        {
          code: 'BKV-OUT',
          name:
            'Luchtkanaal rechthoekig, met brandklep buiten de BSC, opbouw afdichting totaan brandklep excl afdichting',
          icon: '11_bkv-out.svg',
          systems: [
            {
              code: 'WBD60 (1x)',
              name:
                'WBD60 Systeem, 1 x 60 mm HD afdichtplaat 747. Bekleden kanaal tot brandklep met systeem WBD60. Kitnaad rond kanaal in de opening'
            },
            {
              code: 'WBD60 (1x) / Conlit U',
              name:
                'WBD60 Systeem, 1 x 60 mm HD afdichtplaat 747. Bekleden kanaal tot brandklep met systeem WBD60/Conlit U. Kitnaad rond kanaal in de opening'
            },
            {
              code: 'WBD60 (2x)',
              name:
                'WBD60 Systeem, 2 x >50 mm HD afdichtplaat 747. Bekleden kanaal tot brandklep met systeem WBD60. Kitnaad rond kanaal in de opening'
            }
          ],
          sizeCategoryTitle: 'Max zijde in mm',
          sizeCategories: ['100', '200', '250', '300', '500', '600', '750', '1000', '1500', '2000']
        },
        {
          code: 'LKV-BB',
          name: 'Luchtkanaal rechthoek, Brandwerend bekleden hele lengte in ruimte',
          icon: '12_lkv-bb.svg',
          systems: [
            {
              code: 'WBD60 (1x)',
              name: 'WBD60 Systeem, 1 x 60 mm HD afdichtplaat 747'
            }
          ],
          sizeCategoryTitle: 'Max zijde in mm',
          sizeCategories: ['100', '200', '250', '300', '500', '600', '750', '1000', '1500', '2000']
        },
        {
          code: 'LKR-S',
          name: 'Luchtkanaal rechthoek, geen BK, geen Iso, rookdicht afdichten rondom',
          icon: '13_lkr-s.svg',
          systems: [
            {
              code: 'WBD60 (1x) / Conlit U',
              name:
                'WBD60 Systeem, 1 x 60 mm HD afdichtplaat 747\n' +
                'LK geheel bw isoleren Conlit U over lengte in ruimte'
            },
            {
              code: 'WBD60 (1x) / Vlinderklep',
              name: 'WBD60 Systeem, 1 x 60 mm HD afdichtplaat 747\n' + 'Vlinderklep plaatsen'
            },
            {
              code: 'WBD60 (1x) / Brandklep',
              name: 'WBD60 Systeem, 1 x 60 mm HD afdichtplaat 747\n' + 'Doorzagen en ronde brandklep plaatsen'
            },
            {
              code: 'WBD60 (2x) / Conlit U',
              name:
                'WBD60 Systeem, 2 x >50 mm HD afdichtplaat 747\n' +
                'LK geheel bw isoleren Conlit U over lengte in ruimte'
            },
            {
              code: 'WBD60 (2x) / Vlinderklep',
              name: 'WBD60 Systeem, 2 x >50 mm HD afdichtplaat 747\n' + 'Vlinderklep plaatsen'
            },
            {
              code: 'WBD60 (2x) / Brandklep',
              name: 'WBD60 Systeem, 2 x >50 mm HD afdichtplaat 747\n' + 'Doorzagen en ronde brandklep plaatsen'
            }
          ],
          sizeCategoryTitle: 'Kanaaldiameter',
          sizeCategories: ['125', '250', '315', '400', '510', '600']
        },
        {
          code: 'BKR-IN',
          name: 'Luchtkanaal rond, met brandklep in de BSC, rondom afdichten tpv BK',
          icon: '14_bkr-in.svg',
          systems: [
            {
              code: 'WBD60 (1x) / Conlit U',
              name: 'WBD60 Systeem, 1 x 60 mm HD afdichtplaat 747. Brandwerend afdichten ter plaatse van de brandklep'
            }
          ],
          sizeCategoryTitle: 'Kanaaldiameter',
          sizeCategories: ['125', '250', '315', '400', '600']
        },
        {
          code: 'BKR-OUT',
          name: 'Luchtkanaal rond, met brandklep buiten de BSC, opbouw afdichting totaan brandklep excl afdichting',
          icon: '15_bkr-out.svg',
          systems: [
            {
              code: 'WBD60 (1x) / Conlit U',
              name:
                'WBD60 Systeem, 1 x 60 mm HD afdichtplaat 747. Bekleden kanaal tot brandklep met systeem WBD60 / Conlit U. Kitnaad rond kanaal in de opening'
            },
            {
              code: 'WBD60 (2x) / Conlit U',
              name:
                'WBD60 Systeem, 2 x >50 mm HD afdichtplaat 747. Bekleden kanaal tot brandklep met systeem WBD60 / Conlit U. Kitnaad rond kanaal in de opening'
            }
          ],
          sizeCategoryTitle: 'Kanaaldiameter',
          sizeCategories: ['125', '250', '325', '600']
        },
        {
          code: 'LKR-BB',
          name: 'Luchtkanaal rond, brandwerend bekleden hele lengte in ruimte, excl afdichting',
          icon: '16_bkr-bb.svg',
          systems: [
            {
              code: 'WBD60 (1x)',
              name: 'HD Rockwool schalen 60 mm met WBD60 systeem'
            }
          ],
          sizeCategoryTitle: 'Kanaaldiameter',
          sizeCategories: ['125', '250', '325', '600']
        },
        { code: 'LK-zaag', name: 'Luchtkanaal doorzagen tbv vlinderklep', icon: '17_zaag.svg' },
        {
          code: 'LKR-pas',
          name: 'Luchtkanaal rond passtuk plaatsen',
          icon: '18_lkr-pas.svg',
          sizeCategoryTitle: 'Kanaaldiameter',
          sizeCategories: ['125', '200', '300', '400', '500', '600']
        },
        {
          code: 'LK-XX',
          name: 'Luchtkanaal vergroten of verkleinen tbv nieuw te plaatsen brandklep/vlinderklep',
          icon: '19_lk-xx.svg'
        }
      ],
      electricTypes: [
        {
          code: 'KG/KL',
          name: 'Kabelgoot/kabelladder',
          icon: '20_kg_kl.svg',
          systems: [
            {
              code: 'WBD60 (1x)',
              name: 'WBD60 Systeem, 1 x 60 mm HD afdichtplaat 747. Afwerken met Mastic M701/721/722'
            },
            {
              code: 'WBD60 (2x)',
              name: 'WBD60 Systeem, 2 x > 50 mm HD afdichtplaat 747. Afwerken met Mastic M701/721/722'
            }
          ],
          sizeCategoryTitle: 'Afmeting tbv kabelgoot',
          sizeCategories: ['100', '200', '300', '400', '500', '600', '700', '800', '1000']
        },
        {
          code: 'KP/K1',
          name: 'Kabel enkel of elektrabuis < 30mm',
          icon: '21_kp_k1.svg',
          systems: [
            { code: 'M701', name: 'M701 mastic in opening aan brandzijden met coatback 200mm' },
            { code: 'M705', name: 'M705 druk opbouwende mastic' }
          ],
          sizeCategoryTitle: 'Afmeting',
          sizeCategories: ['10', '20', '30']
        },
        {
          code: 'KB',
          name: 'Kabelbundel',
          icon: '22_kb.svg',
          systems: [{ code: 'M705', name: 'M705 druk opbouwende mastic' }],
          sizeCategoryTitle: 'Afmeting',
          sizeCategories: ['30', '50', '75', '100', '125', '150', '200', '300']
        },
        {
          code: 'KM',
          name: 'Kabel mantelbuis <100mm',
          icon: '23_km.svg',
          systems: [{ code: 'M705', name: 'M705 druk opbouwende mastic' }],
          sizeCategoryTitle: 'Afmeting',
          sizeCategories: ['35', '50', '75', '100']
        },
        {
          code: 'WCD',
          name: 'Wandcontactdoos enkel',
          icon: '24_wcd.svg',
          systems: [{ code: 'Putty Pads', name: 'Putty pads' }],
          sizeCategoryTitle: 'Afmeting',
          sizeCategories: ['50']
        },
        {
          code: 'WCD-2',
          name: 'Wandcontactdoos dubbel',
          icon: '25_wcd2.svg',
          systems: [{ code: 'Putty Pads', name: 'Putty pads' }],
          sizeCategoryTitle: 'Afmeting',
          sizeCategories: ['100']
        }
      ],

      plumbingTypes: [
        {
          code: 'PP (1z)',
          name: 'Plastic pijp - no iso',
          icon: '26_pp.svg',
          systems: [
            { code: 'B150 manchet / B747-60', name: 'B150 manchet. B747-60 2x' },
            { code: 'B150 manchet / M710', name: 'B150 manchet. M701 mastic in ringmaat tbv S rating' },
            { code: 'B300', name: 'B300 Pijpwikkel. Rignmaat afkitten M701' },
            { code: 'M705', name: 'M705 drukopbouwende mastic. Diepte = 25mm' },
            { code: 'N.V.T.', name: 'N.V.T.' }
          ],
          sizeCategoryTitle: 'Manchetmaat',
          sizeCategories: ['40', '55', '75', '82', '90', '110', '125', '160', '200', '250', '300']
        },
        {
          code: 'PP (2z)',
          name: 'Plastic pijp - no iso',
          icon: '27_pp2z.svg',
          systems: [
            { code: 'M705', name: 'M705 drukopbouwende mastic. Diepte = 25mm' },
            { code: 'B150 manchet / B747-60', name: 'B150 manchet. B747-60 2x' },
            { code: 'B150 manchet / M710', name: 'B150 manchet. M701 mastic in ringmaat tbv S rating' },
            { code: 'B300', name: 'B300 Pijpwikkel. Rignmaat afkitten M701' },
            { code: 'N.V.T.', name: 'N.V.T.' }
          ],
          sizeCategoryTitle: 'Diameter (mm)',
          sizeCategories: ['20', '45', '75', '90', '110', '125']
        },
        {
          code: 'PP+',
          name: 'Plastic pijp + iso',
          icon: '28_pp_plus.svg',
          systems: [{ code: 'M705', name: 'M705 drukopbouwende mastic. Diepte = 25mm' }],
          sizeCategoryTitle: 'Diameter (mm)',
          sizeCategories: ['30', '50', '75', '90', '110', '125', '160', '200', '250', '300'],
          isolations: ['AD', 'AS']
        },
        {
          code: 'PP-grp',
          name: 'Bundel van PP in groep',
          icon: '29_pp_grp.svg',
          systems: [{ code: 'Schakelmanchet Promat', name: 'Schakelmanchet Promat' }],
          sizeCategoryTitle: 'Afmeting',
          sizeCategories: ['100', '200', '300', '400', '500']
        },
        {
          code: 'PP scheef',
          name: 'PP scheef in doorvoer',
          icon: '30_pp_scheef.svg',
          systems: [{ code: 'M705', name: 'M705 drukopbouwende mastic. Diepte = 25mm' }],
          sizeCategoryTitle: 'Afmeting',
          sizeCategories: ['30', '50', '75', '90', '110', '125']
        },
        {
          code: 'PP-UB',
          name: 'PP met PH plaat op wand, of WBD en manchet',
          icon: '31_pp_ub.svg',
          systems: [{ code: 'B150 + WBD/PH', name: 'B150 manchet en WBD/PH plaat' }],
          sizeCategoryTitle: 'Diameter (mm)',
          sizeCategories: ['40', '50', '83', '110', '125', '160', '200', '250', '300']
        },
        {
          code: 'PP opstort',
          name: 'PP bovenop vloer in beton opstort',
          icon: '32_pp_opstort.svg',
          systems: [{ code: 'B150 + beton', name: 'B150 manchet en beton' }],
          sizeCategoryTitle: 'Diameter (mm)',
          sizeCategories: ['40', '55', '75', '82', '90', '110', '125', '160']
        },
        {
          code: 'MB0',
          name: 'Metalen buis zonder isolatie',
          icon: '33_mb0.svg',
          systems: [
            {
              code: 'WBD60 (1x)',
              name: 'WBD60 Systeem, 1x 60 mm HD afdichtplaat 747. Afwerken met Mastic M701/721/722'
            },
            {
              code: 'WBD60 (2x)',
              name: 'WBD60 systeem, 2 x 60mm HD afdichtplaat 747. Afwerken met Mastic M701/721/722'
            }
          ],
          sizeCategoryTitle: 'Diameter (mm)',
          sizeCategories: ['25', '50', '75', '100', '150', '200', '250', '300', '400', '500'],
          isolations: ['0']
        },
        {
          code: 'MBA',
          name: 'Metalen buis met armaflex doorlopend',
          icon: '34_mba.svg',
          systems: [
            { code: 'M705', name: 'M705 druk opbouwende mastic. Diepte = 25mm' },
            { code: 'B150', name: 'B150 manchet' },
            { code: 'PL strip', name: 'Opschuimende strip' }
          ],
          sizeCategoryTitle: 'Diameter (mm)',
          sizeCategories: ['25', '50', '75', '100', '150', '200', '250', '300', '400', '500'],
          isolations: ['A']
        },
        {
          code: 'MBS',
          name: 'Metalen buis met steenwolisolatie doorlopend brandwerend afdichten',
          icon: '35_mbs.svg',
          systems: [
            { code: 'M701', name: 'M701 mastic. M722. Steenwol moet HD 150kg/m3 zijn, anders vervangen' },
            {
              code: 'WBD60 (1x)',
              name:
                'WBD60 Systeem, 1 x 60 mm HD afdichtplaat 747. Afwerken met Mastic M701/721/722. Isolatie buiten DV: RW810 d>20 mm'
            },
            {
              code: 'WBD60 (2x)',
              name: 'WBD60 systeem, 2 x 60mm HD afdichtplaat 747. Afwerken met Mastic M701/721/722'
            }
          ],
          sizeCategoryTitle: 'Diameter (mm)',
          sizeCategories: ['25', '50', '75', '100', '150', '200', '250', '300', '400', '500'],
          isolations: ['SD', 'SS']
        },
        {
          code: 'MBG',
          name: 'Metalen buis met glaswol isolatie doorlopend brandwerend afdichten',
          icon: '36_mbg.svg',
          systems: [
            {
              code: 'WBD60 (1x)',
              name: 'WBD60 Systeem, 1x 60 mm HD afdichtplaat 747. Afwerken met Mastic M701/721/722'
            },
            {
              code: 'WBD60 (2x)',
              name: 'WBD60 systeem, 2 x 60mm HD afdichtplaat 747. Afwerken met Mastic M701/721/722'
            }
          ],
          sizeCategoryTitle: 'Diameter (mm)',
          sizeCategories: ['25', '50', '75', '100', '150', '200', '250', '300', '400', '500'],
          isolations: ['G']
        },
        {
          code: 'MBX',
          name: 'Metalen buis met hard kunststof isolatie doorlopend brandwerend afdichten',
          icon: '37_mbx.svg',
          systems: [{ code: 'M705', name: 'M705 druk opbouwende mastic. Diepte = 25mm' }],
          sizeCategoryTitle: 'Diameter (mm)',
          sizeCategories: ['25', '50', '75', '100', '150', '200', '250', '300', '400', '500'],
          isolations: ['X']
        }
      ],

      jointTypes: [
        {
          code: 'LV-V',
          name: 'Bouwkundige lineaire voeg, verticaal per m1',
          icon: '38_lv-v.svg',
          systems: [
            {
              code: 'M701',
              name: 'M710 mastic. Rugvulling PE/PU/Steenwol. Rugvulling steenwol 60 kg/m3 bij grotere voeg'
            },
            {
              code: 'M703',
              name: 'M703 mastic. Rugvulling PE/PU/Steenwol. Rugvulling steenwol 60 kg/m3 bij grotere voeg'
            },
            { code: 'Systeem J', name: 'Systeem J. Dubbel uitvoeren' },
            { code: 'WBD60', name: 'WBD60. 60mm dik' }
          ],
          sizeCategoryTitle: 'Voegbreedte (mm)',
          sizeCategories: ['10', '15', '20', '25', '30', '35', '40', '45', '50']
        },
        {
          code: 'DIL-V',
          name: 'Bouwkundige lineaire dilatatievoeg, verticaal per m1',
          icon: '39_dil-v.svg',
          systems: [
            {
              code: 'M701',
              name: 'M710 mastic. Rugvulling PE/PU/Steenwol. Rugvulling steenwol 60 kg/m3 bij grotere voeg'
            },
            {
              code: 'M703',
              name: 'M703 mastic. Rugvulling PE/PU/Steenwol. Rugvulling steenwol 60 kg/m3 bij grotere voeg'
            },
            { code: 'Systeem J', name: 'Systeem J. Dubbel uitvoeren' },
            { code: 'WBD60', name: 'WBD60. 60mm dik' }
          ],
          sizeCategoryTitle: 'Voegbreedte (mm)',
          sizeCategories: ['10', '15', '20', '25', '30', '35', '40', '45', '50']
        },
        {
          code: 'LV-H',
          name: 'Bouwkundige lineaire voeg, horizontaal per m1',
          icon: '40_lv-h.svg',
          systems: [
            {
              code: 'FS700 + Steenwol 60kg',
              name: 'FS700 + Steenwol 60kg. Rugvulling steenwol 60kg/m3 tot 150mm diep'
            },
            {
              code: 'M701',
              name: 'M710 mastic. Rugvulling PE/PU/Steenwol. Rugvulling steenwol 60 kg/m3 bij grotere voeg'
            },
            {
              code: 'M703',
              name: 'M703 mastic. Rugvulling PE/PU/Steenwol. Rugvulling steenwol 60 kg/m3 bij grotere voeg'
            },
            { code: 'Systeem J', name: 'Systeem J' },
            { code: 'Systeem J (dubbel)', name: 'Systeem J. Dubbel uitvoeren' },
            { code: 'WBD60', name: 'WBD60. 60mm dik' }
          ],
          sizeCategoryTitle: 'Voegbreedte (mm)',
          sizeCategories: ['10', '15', '20', '25', '30', '35', '40', '45', '50']
        },
        {
          code: 'DIL-H',
          name: 'Bouwkundige lineaire dilatatievoeg, horizontaal per m1',
          icon: '41_dil-h.svg',
          systems: [
            { code: 'Bicks B400', name: 'Bicks B400' },
            {
              code: 'FS700 + Steenwol 60kg',
              name: 'FS700 + Steenwol 60kg. Rugvulling steenwol 60kg/m3 tot 150mm diep'
            },
            {
              code: 'M701',
              name: 'M710 mastic. Rugvulling PE/PU/Steenwol. Rugvulling steenwol 60 kg/m3 bij grotere voeg'
            },
            {
              code: 'M703',
              name: 'M703 mastic. Rugvulling PE/PU/Steenwol. Rugvulling steenwol 60 kg/m3 bij grotere voeg'
            },
            { code: 'Systeem J', name: 'Systeem J. Dubbel uitvoeren' },
            { code: 'WBD60', name: 'WBD60. 60mm dik' }
          ],
          sizeCategoryTitle: 'Voegbreedte (mm)',
          sizeCategories: ['10', '15', '20', '25', '30', '35', '40', '45', '50']
        },
        {
          code: 'CAN',
          name: 'Cannelure',
          icon: '42_can.svg',
          systems: [
            { code: 'Cannelurevulling (65 kg/m3)', name: 'Cannelurevulling lage densiteit (65 kg/m3)' },
            { code: 'Cannelurevulling (150 kg/m3)', name: 'Cannelurevulling hoge densiteit (150 kg/m3)' }
          ],
          sizeCategoryTitle: 'Afmeting (mm)',
          sizeCategories: ['75', '100', '200', '300']
        },
        {
          code: 'BDV-m1',
          name: 'Bouwkundige doorvoering (ligger e.d.) brandwerend afdichten per m1',
          icon: '43_bdv-m1.svg',
          systems: [
            {
              code: 'FS700 + Steenwol 60kg',
              name: 'FS700 + Steenwol 60kg. Rugvulling steenwol 60kg/m3 tot 150mm diep'
            },
            {
              code: 'M701',
              name: 'M710 mastic. Rugvulling PE/PU/Steenwol. Rugvulling steenwol 60 kg/m3 bij grotere voeg'
            },
            {
              code: 'M703',
              name: 'M703 mastic. Rugvulling PE/PU/Steenwol. Rugvulling steenwol 60 kg/m3 bij grotere voeg'
            },
            { code: 'Systeem J', name: 'Systeem J. Dubbel uitvoeren' },
            { code: 'WBD60', name: ' WBD60. 60mm dik' }
          ],
          sizeCategoryTitle: 'Max zijde in mm',
          sizeCategories: ['100', '250', '500', '750', '1000', '1500', '2000', '3000']
        },
        {
          code: 'BDV-m2',
          name: 'Bouwkundige doorvoering (ligger e.d.) brandwerend afdichten per m2',
          icon: '44_bdv-m2.svg',
          systems: [
            {
              code: 'FS700 + Steenwol 60kg',
              name: 'FS700 + Steenwol 60kg. Rugvulling steenwol 60kg/m3 tot 150mm diep'
            },
            {
              code: 'M701',
              name: 'M710 mastic. Rugvulling PE/PU/Steenwol. Rugvulling steenwol 60 kg/m3 bij grotere voeg'
            },
            {
              code: 'M703',
              name: 'M703 mastic. Rugvulling PE/PU/Steenwol. Rugvulling steenwol 60 kg/m3 bij grotere voeg'
            },
            { code: 'Systeem J', name: 'Systeem J. Dubbel uitvoeren' },
            { code: 'WBD60', name: 'WBD60. 60mm dik' }
          ],
          sizeCategoryTitle: 'Oppervlak in m2',
          sizeCategories: ['0.1', '0.2', '0.3', '0.4', '0.5', '0.6', '0.7', '0.8', '0.9', '1.0', '1.5', '2.0']
        },
        {
          code: 'BDV-#',
          name: 'Bouwkundige doorvoering (ligger e.d.) brandwerend afdichten speciaal',
          icon: '45_bdv-#.svg',
          systems: [
            {
              code: 'FS700 + Steenwol 60kg',
              name: 'FS700 + Steenwol 60kg. Rugvulling steenwol 60kg/m3 tot 150mm diep'
            },
            {
              code: 'M701',
              name: 'M710 mastic. Rugvulling PE/PU/Steenwol. Rugvulling steenwol 60 kg/m3 bij grotere voeg'
            },
            {
              code: 'M703',
              name: 'M703 mastic. Rugvulling PE/PU/Steenwol. Rugvulling steenwol 60 kg/m3 bij grotere voeg'
            },
            { code: 'Systeem J', name: 'Systeem J. Dubbel uitvoeren' },
            { code: 'WBD60', name: 'WBD60. 60mm dik' }
          ]
        },
        {
          code: 'GVA',
          name: 'Brandwerend afdichten gevel-vloer aansluiting',
          icon: '46_gva.svg',
          systems: [
            { code: 'FS700 + Steenwol 60kg', name: 'FS700 + Steenwol 60kg. Rugvulling steenwol 60kg/m3 tot 150mm diep' }
          ]
        }
      ],

      actionTypes: [
        {
          code: 'Meld',
          name: 'Meldcode: doormelden naar klant inzake situatie buiten onze scope',
          icon: '47_meld.svg',
          hasLength: false
        },
        {
          code: 'Overleg',
          name: 'Verzoek tot overleg over afdichting. PL actie',
          icon: '48_overleg.svg',
          hasLength: false
        },
        {
          code: 'ISO -/+',
          name: 'Isolatie verwijderen en  na afdichten terugplaatsen on doorvoer',
          icon: '49_iso.svg',
          hasLength: false,
          sizeCategoryTitle: 'Tijd in min',
          sizeCategories: ['5', '10', '15', '20', '25', '30', '60', '90']
        },
        { code: 'BGL-R', name: 'Beugel plaatsen - ronde doovoering', icon: '50_bgl-r.svg', hasLength: false },
        {
          code: 'BGL-V',
          name: 'Beugel plaatsen - rechthoekige doorvoering',
          icon: '51_bgl-v.svg',
          hasLength: false
        },
        { code: 'QR-sticker', name: 'Extra QR-sticker plaatsen', icon: '52_qr-sticker.svg', hasLength: false },
        {
          code: 'Repair',
          name: 'Schadeherstel, reparatie bestaande doorvoerafdichting',
          icon: '53_repair.svg',
          hasLength: false
        },
        { code: 'PUR -', name: 'Pur verwijderen uit sparing/naad', icon: '54_pur-.svg', hasLength: false },
        {
          code: 'SPAR +',
          name: 'Sparing vergroten om brandwerend systeem aan te brengen',
          icon: '55_spar.svg',
          hasLength: false
        },
        {
          code: 'Plaf -/+',
          name: 'Plafond verwijderen en na afdichting weer terugplaatsen',
          icon: '56_plaf.svg',
          hasLength: false,
          sizeCategoryTitle: 'Tijd in min',
          sizeCategories: ['5', '10', '15', '20', '25', '30', '60', '90']
        },
        {
          code: 'Stofschot',
          name: 'Stofschot plaatsen voor werkzaamheden en later verwijderen',
          icon: '57_stofschot.svg',
          hasLength: false
        },
        {
          code: 'Meubels',
          name: 'Meubels verplaatsen ivm bereikbaarheid; wegzetten en terugzetten',
          icon: '58_meubels.svg',
          hasLength: false,
          sizeCategoryTitle: 'Tijd in min',
          sizeCategories: ['5', '10', '15', '20', '25', '30', '60', '90']
        },
        { code: 'DV -', name: 'Doorvoering verwijderen', icon: '59_dv-.svg', hasLength: false },
        {
          code: 'Tijd bereik',
          name: 'Extra tijd nodig voor bereikbaarheid',
          icon: '60_tijd-bereik.svg',
          hasLength: false
        },
        { code: 'Tijd', name: 'Algemene melding extra tijd', icon: '61_tijd.svg', hasLength: false },
        {
          code: 'PH plaat',
          name: 'Proma H plaat incl. bevestigen',
          icon: '62_ph-plaat.svg',
          hasLength: false
        },
        { code: 'Boor', name: 'Booractie t.b.v. bevestiging', icon: '63_boor.svg', hasLength: false }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Projects/bigData.js